import { CbhIcon } from "@clipboard-health/ui-components";
// eslint-disable-next-line no-restricted-imports
import { IconButton } from "@mui/material";

import { type NavigationVariant } from "../Insight/getNavigationVariant";

interface WrappedNavigationButtonProps {
  direction: "previous" | "next";
  variant: NavigationVariant;
  disabled?: boolean;
  onClick: () => void;
}

export function WrappedNavigationButton(props: WrappedNavigationButtonProps) {
  const { direction, variant, disabled = false, onClick } = props;

  const colors =
    variant === "light"
      ? {
          // eslint-disable-next-line no-restricted-syntax
          icon: "#FFFFFF",

          background: "rgba(255, 255, 255, 0.35)",
          disabledIcon: "rgba(255, 255, 255, 0.3)",
          disabledBackground: "rgba(255, 255, 255, 0.15)",
        }
      : {
          // eslint-disable-next-line no-restricted-syntax
          icon: "#000000",

          background: "rgba(255, 255, 255, 0.35)",
          disabledIcon: "rgba(0, 0, 0, 0.2)",
          disabledBackground: "rgba(255, 255, 255, 0.2)",
        };

  return (
    <IconButton
      size="small"
      disabled={disabled}
      sx={{
        backgroundColor: disabled ? colors.disabledBackground : colors.background,
        borderRadius: "50%",
        padding: 1,
        color: disabled ? colors.disabledIcon : colors.icon,
        "&:hover": {
          backgroundColor:
            variant === "light" ? "rgba(255, 255, 255, 0.45)" : "rgba(255, 255, 255, 0.45)",
        },
        "&.Mui-disabled": {
          color: colors.disabledIcon,
          backgroundColor: colors.disabledBackground,
        },
      }}
      onClick={onClick}
    >
      <CbhIcon type={direction === "previous" ? "chevron-left" : "chevron-right"} size="small" />
    </IconButton>
  );
}
